import PropTypes from "prop-types";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";
import { Box } from "@mui/material";
const FetchImage = ({ relationship, sx }) => {
  return (
    <Box component={"div"} sx={{ ...sx, position: "relative" }}>
      <Image
        alt={relationship}
        fill
        priority
        src={`${IMAGE_BASE_PATH}/images/${relationship}.svg`}
      />
    </Box>
  );
};

FetchImage.propTypes = {
  relationship: PropTypes.string,
  sx: PropTypes.object,
};
export default FetchImage;
